export default function normalizeDxDyValue1(dxOrDy: number) {
  if (dxOrDy > 0) {
    return 1
  } else if (dxOrDy < 0) {
    return -1
  } else {
    return 0
  }
}

